import React, { useEffect, useState } from "react";

import { ExpandLess } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { theme } from "@/src/theme/theme";

const SCROLL_Y_LIMIT = 240;

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(window.scrollY > SCROLL_Y_LIMIT);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_Y_LIMIT ? true : false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <IconButton
      sx={{
        position: "fixed",
        display: isVisible ? "flex" : "none",
        right: "1rem",
        bottom: "1rem",
        border: "1px solid",
        borderColor: theme.palette.semantic.primary.main,
        background: "background.paper",
        "&:hover": {
          backgroundColor: theme.palette.misc.timelineBackground
        },
        zIndex: 100
      }}
      onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }}
    >
      <ExpandLess sx={{ color: theme.palette.semantic.primary.main }} />
    </IconButton>
  );
};

export default ScrollToTop;
